import React, { useContext, useEffect, useState } from 'react';
import {
  arrayOf, bool, func, number, oneOf, shape, string
} from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { AddToCart } from '@thd-olt-component-react/add-to-cart';
import {
  FULFILLMENT_METHOD_BODFS,
  FULFILLMENT_METHOD_STH
} from '../../constants';
import { getCartOptions, getCartReqParams } from '../../BuyboxHelper';

import '../buybox.scss';

const BuyboxAddToCart = ({
  alterBrowserHistory,
  disableATC,
  fulfillment,
  fulfillmentMethod,
  isAssembleItemAtStore,
  itemId,
  onATCClick,
  productAddOns = {},
  quantity,
  quantityLimitExceed,
  storeId,
  storeZip,
  zipCode
}) => {
  const { channel } = useContext(ExperienceContext);

  const BODFS = fulfillmentMethod === FULFILLMENT_METHOD_BODFS;
  const STH = fulfillmentMethod === FULFILLMENT_METHOD_STH;

  const [bogoSelectedProduct, setBogoSelectedProduct] = useState();
  const bogoSelectedProductOnChange = (bogoSelected) => {
    setBogoSelectedProduct(bogoSelected?.output);
  };
  useEffect(() => {
    window.LIFE_CYCLE_EVENT_BUS.lifeCycle.on('buybox.bogoSelectedProduct', bogoSelectedProductOnChange);
    return () => window.LIFE_CYCLE_EVENT_BUS.lifeCycle.off('buybox.bogoSelectedProduct');
  }, []);

  const buttonText = bogoSelectedProduct?.itemId ? 'Add Both to Cart' : 'Add to Cart';
  const isSusbcribeAndSaveOpted = !!productAddOns?.subscriptions?.frequency;

  return (
    <div className="buybox__atc">
      <AddToCart
        cartOptions={getCartOptions({
          alterBrowserHistory,
          bogoSelectedProduct,
          channel,
          fulfillmentMethod,
          storeId,
          storeZip,
          zipCode
        })}
        cartReqParams={getCartReqParams({
          bogoSelectedProduct,
          fulfillment,
          fulfillmentMethod,
          isAssembleItemAtStore,
          itemId,
          quantity,
          productAddOns,
          storeId,
          storeZip,
          zipCode
        })}
        disabled={disableATC || quantityLimitExceed}
        onClick={onATCClick}
        small={false}
      >
        {isSusbcribeAndSaveOpted ? 'Subscribe' : buttonText }
      </AddToCart>
    </div>
  );
};

BuyboxAddToCart.propTypes = {
  alterBrowserHistory: bool,
  disableATC: bool,
  fulfillment: shape({
    type: string,
    locations: arrayOf(shape({
      isAnchor: bool,
      inventory: shape({
        quantity: number,
        isInStock: bool,
        isLimitedQuantity: bool,
        isBackordered: bool
      })
    }))
  }),
  fulfillmentMethod: string,
  isAssembleItemAtStore: bool,
  itemId: string.isRequired,
  onATCClick: func,
  productAddOns: shape({
    attachedLabor: arrayOf(shape({
      attachedLaborSku: string
    })),
    warrantyItem: shape({
      itemId: string
    })
  }),
  quantity: number,
  quantityLimitExceed: bool,
  storeId: string,
  storeZip: string,
  zipCode: string
};

BuyboxAddToCart.defaultProps = {
  alterBrowserHistory: false,
  disableATC: false,
  fulfillment: null,
  fulfillmentMethod: '',
  isAssembleItemAtStore: null,
  onATCClick: () => {},
  productAddOns: null,
  quantity: 1,
  quantityLimitExceed: false,
  storeId: null,
  storeZip: null,
  zipCode: null
};

export { BuyboxAddToCart };
